// @noflow
import { Background, ClickableArea, Container, Line, Opacity } from './style';

import PropTypes from 'prop-types';
import * as React from 'react';

AddEventButton.propTypes = {
    addEvent: PropTypes.func.isRequired,
    eventHeight: PropTypes.number.isRequired,
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
};

export default function AddEventButton({ addEvent, eventHeight, left, top }) {
    const r = eventHeight * 0.35;
    return (
        <Opacity>
            <Container
                onClick={addEvent}
                style={{ transform: `translate3d(${left}px, ${top}px, 0)` }}
                transform={`translate(${left} ${top})`}
            >
                <ClickableArea height={eventHeight} width={eventHeight} x={-eventHeight / 2} y={-eventHeight / 2} />
                <Background r={r} />
                <Line d={`M${-r * 0.5} 0 h ${r}`} />
                <Line d={`M0 ${-r * 0.5} v ${r}`} />
            </Container>
        </Opacity>
    );
}



// WEBPACK FOOTER //
// ./src/components/widgets/schedule/day/add-event-button/component.js